import { Toaster as Sonner } from 'sonner';
import { useTheme } from 'next-themes';

export function Toaster() {
  const { theme = 'system' } = useTheme();
  return (
    <Sonner
      theme={theme as 'light' | 'dark' | 'system'}
      /* top-center: bottom-right colidia com a bolha do widget de chat (toast sumia atrás). */
      position="top-center"
      richColors
      toastOptions={{
        classNames: {
          toast: 'group rounded-md border bg-card text-card-foreground shadow-lg',
          description: 'text-muted-foreground',
        },
      }}
    />
  );
}
